define("shared/components/shared/credentials/connection-failure", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/template", "@ember/service", "@ember/object/computed"], function (_exports, _component, _templateFactory, _component2, _object, _template, _service, _computed) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@ember/template",0,"@ember/service",0,"@ember/object/computed",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal
    @close={{action @close}}
    @closable={{false}}
  as |modal|>
  
    <modal.card
      @portrait={{true}}
      @closeIcon={{false}}
      class="is--dark u--p__0"
    >
      <modal.card-header @title={{this.headerText}} />
      <modal.card-body class="u--p__t__0">
  
        <p>
          {{html-safe this.connectionFailureSubtitle}}
        </p>
  
        <div class="u--p__t__lg">
          <Shared::Link
            class="o--btn o--btn--primary o--btn--block o--btn--lg"
            @href={{this.helpArticleLink}}
            @text={{t "customer_support.docs_only.continue"}}
          />
          {{#if this.canContactForm}}
            <Shared::Ui::Button
              @type="default"
              @additional="block"
              @size="large"
              @onClick={{this.openChatbot}}
              @text={{t "customer_support.can_contact.continue"}}
            />
          {{/if}}
          <a
            class="u--text--hl u--text--center u--block u--m__t__sm u--m__b"
            {{on "click" (action @dismissContactUs)}}
          >
            {{t (concat "customer_support." (if this.canUserContactSupport "can_contact" "docs_only") ".exit")}}
          </a>
  
        </div>
  
      </modal.card-body>
    </modal.card>
  </Shared::Modal>
  
  */
  {
    "id": "ESj29xj7",
    "block": "[[[8,[39,0],null,[[\"@close\",\"@closable\"],[[28,[37,1],[[30,0],[30,1]],null],false]],[[\"default\"],[[[[1,\"\\n\\n  \"],[8,[30,2,[\"card\"]],[[24,0,\"is--dark u--p__0\"]],[[\"@portrait\",\"@closeIcon\"],[true,false]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card-header\"]],null,[[\"@title\"],[[30,0,[\"headerText\"]]]],null],[1,\"\\n    \"],[8,[30,2,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n\\n      \"],[10,2],[12],[1,\"\\n        \"],[1,[28,[35,2],[[30,0,[\"connectionFailureSubtitle\"]]],null]],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,0],[14,0,\"u--p__t__lg\"],[12],[1,\"\\n        \"],[8,[39,3],[[24,0,\"o--btn o--btn--primary o--btn--block o--btn--lg\"]],[[\"@href\",\"@text\"],[[30,0,[\"helpArticleLink\"]],[28,[37,4],[\"customer_support.docs_only.continue\"],null]]],null],[1,\"\\n\"],[41,[30,0,[\"canContactForm\"]],[[[1,\"          \"],[8,[39,6],null,[[\"@type\",\"@additional\",\"@size\",\"@onClick\",\"@text\"],[\"default\",\"block\",\"large\",[30,0,[\"openChatbot\"]],[28,[37,4],[\"customer_support.can_contact.continue\"],null]]],null],[1,\"\\n\"]],[]],null],[1,\"        \"],[11,3],[24,0,\"u--text--hl u--text--center u--block u--m__t__sm u--m__b\"],[4,[38,7],[\"click\",[28,[37,1],[[30,0],[30,3]],null]],null],[12],[1,\"\\n          \"],[1,[28,[35,4],[[28,[37,8],[\"customer_support.\",[52,[30,0,[\"canUserContactSupport\"]],\"can_contact\",\"docs_only\"],\".exit\"],null]],null]],[1,\"\\n        \"],[13],[1,\"\\n\\n      \"],[13],[1,\"\\n\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]],[1,\"\\n\"]],[\"@close\",\"modal\",\"@dismissContactUs\"],false,[\"shared/modal\",\"action\",\"html-safe\",\"shared/link\",\"t\",\"if\",\"shared/ui/button\",\"on\",\"concat\"]]",
    "moduleName": "shared/components/shared/credentials/connection-failure.hbs",
    "isStrictMode": false
  });

  let ConnectionFailure = (_dec = (0, _computed.alias)('credentials.socialProfile'), _dec2 = (0, _computed.alias)('credentials.state'), _dec3 = (0, _computed.readOnly)('zendesk.widgetPermissions.canContactForm'), _dec4 = (0, _computed.readOnly)('socialProfile.hasProfessionalAccount'), _dec5 = (0, _computed.readOnly)('socialProfile.isCreator'), _dec6 = (0, _computed.readOnly)('auth.currentUserModel.email'), (_class = class ConnectionFailure extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "ada", _descriptor, this);

      _initializerDefineProperty(this, "auth", _descriptor2, this);

      _initializerDefineProperty(this, "credentials", _descriptor3, this);

      _initializerDefineProperty(this, "intl", _descriptor4, this);

      _initializerDefineProperty(this, "segment", _descriptor5, this);

      _initializerDefineProperty(this, "zendesk", _descriptor6, this);

      _initializerDefineProperty(this, "socialProfile", _descriptor7, this);

      _initializerDefineProperty(this, "state", _descriptor8, this);

      _initializerDefineProperty(this, "canContactForm", _descriptor9, this);

      _initializerDefineProperty(this, "isRefreshFailure", _descriptor10, this);

      _initializerDefineProperty(this, "isCreator", _descriptor11, this);

      _initializerDefineProperty(this, "userEmail", _descriptor12, this);
    }

    get connectionFailureSubtitle() {
      const subTitleKey = "sub_title_".concat(this.failureType);
      const translationString = "credentials.connection_failure.zendesk.".concat(this.canContactForm ? 'can_contact' : 'docs_only', ".").concat(subTitleKey);
      return this.intl.t(translationString, {
        nickname: this.socialProfile.nickname,
        email: this.userEmail,
        setup_goal: this.setupGoalText
      });
    }

    get failureType() {
      if (this.isRefreshFailure) {
        return 'refresh';
      }

      return 'setup';
    }

    get isInfluencer() {
      return this.socialProfile.businessModel === 'blog_influencer' && this.args.source === 'partnerships';
    }

    get headerText() {
      let key = "credentials.connection_failure.title_".concat(this.failureType);

      if (this.isCreator) {
        key = key + '_creator';
      } else if (this.isInfluencer) {
        key = key + '_influencer';
      }

      return (0, _template.htmlSafe)(this.intl.t(key));
    }

    get setupGoalText() {
      if (this.isCreator) {
        return this.intl.t('credentials.connection_failure.creator_setup_goal', {
          nickname: this.socialProfile.nickname
        });
      } else if (this.isInfluencer) {
        return this.intl.t('credentials.connection_failure.influencer_setup_goal', {
          nickname: this.socialProfile.nickname
        });
      }

      return this.intl.t('credentials.connection_failure.business_setup_goal', {
        nickname: this.socialProfile.nickname
      });
    }

    get helpArticleLink() {
      return this.isInfluencer ? 'https://help.later.com/hc/en-us/articles/1500000110062' : 'https://help.later.com/hc/articles/360050382474';
    }

    openChatbot() {
      this.ada.open();
      this.segment.track('initiated-contact-us-creds-wiz', {
        social_profile: this.socialProfile,
        page_name: 'settings'
      });
      this.args.close();
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "ada", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "credentials", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "zendesk", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "socialProfile", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "state", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "canContactForm", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "isRefreshFailure", [_dec4], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "isCreator", [_dec5], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "userEmail", [_dec6], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "openChatbot", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openChatbot"), _class.prototype)), _class));
  _exports.default = ConnectionFailure;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ConnectionFailure);
});